
import { Card, CardContent } from "@/components/ui/card";
import { FilePlus, FileSearch } from "lucide-react";
import { CreateResourceDialog } from "@/components/CreateResourceDialog";

interface ResourcesEmptyProps {
  isTrainee?: boolean;
}

export const ResourcesEmpty = ({ isTrainee }: ResourcesEmptyProps) => (
  <Card>
    <CardContent className="pt-6">
      <div className="text-center py-8">
        {isTrainee ? (
          <>
            <FileSearch className="mx-auto h-12 w-12 text-gray-400 mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              No resources shared yet
            </h3>
            <p className="text-gray-500 mb-4 max-w-sm mx-auto">
              You don't have any training resources shared with you yet. Your administrator will share resources with you when they're ready.
            </p>
          </>
        ) : (
          <>
            <FilePlus className="mx-auto h-12 w-12 text-gray-400 mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              Create your first training resource
            </h3>
            <p className="text-gray-500 mb-4 max-w-sm mx-auto">
              Get started by creating your first training resource. You can add documents, videos, or other materials to help train your team.
            </p>
            <CreateResourceDialog />
          </>
        )}
      </div>
    </CardContent>
  </Card>
);
